function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo } from 'react';
import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from '@tapresearch/ui/components';
export var RankingQuestionTable = function(param) {
    var usePercentage = param.usePercentage, results = param.results, tapAnswers = param.tapAnswers;
    var sortedAnswers = useMemo(function() {
        return Object.entries(results).sort(function(a, b) {
            var _a_, _b_;
            return ((_a_ = a[1]) === null || _a_ === void 0 ? void 0 : _a_.average_rank) - ((_b_ = b[1]) === null || _b_ === void 0 ? void 0 : _b_.average_rank);
        });
    }, [
        results
    ]);
    var tapAnswersLabelsHash = useMemo(function() {
        return tapAnswers.reduce(function(acc, answer) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, answer.attributes.id.toString(), answer.attributes.option_text));
        }, {});
    }, [
        tapAnswers
    ]);
    return /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "ranking-result-table",
        flexGrow: 1,
        my: {
            base: 5,
            md: 8
        },
        w: "full",
        overflowX: "scroll",
        overflowY: "scroll",
        maxH: "500px"
    }, /*#__PURE__*/ React.createElement(Table, {
        variant: "simple",
        sx: {
            borderCollapse: 'separate',
            borderSpacing: '0'
        }
    }, /*#__PURE__*/ React.createElement(Thead, null, /*#__PURE__*/ React.createElement(Tr, {
        sx: {
            th: {
                textTransform: 'none',
                color: 'gray.900',
                fontWeight: 'normal',
                fontSize: 'sm',
                letterSpacing: 0,
                position: 'sticky',
                top: 0,
                bg: 'white'
            }
        }
    }, /*#__PURE__*/ React.createElement(Th, null, "Rank"), /*#__PURE__*/ React.createElement(Th, null, "Item"), /*#__PURE__*/ React.createElement(Th, null, "Avg rank"), tapAnswers.map(function(_, i) {
        return /*#__PURE__*/ React.createElement(Th, {
            key: i,
            textAlign: "center"
        }, "#", i + 1);
    }))), /*#__PURE__*/ React.createElement(Tbody, null, sortedAnswers.map(function(param, rankIndex) {
        var _param = _sliced_to_array(param, 2), answerId = _param[0], answer = _param[1];
        var averageRank = answer.average_rank, ranks = answer.ranks, total = answer.total;
        return /*#__PURE__*/ React.createElement(Tr, {
            key: rankIndex
        }, /*#__PURE__*/ React.createElement(Td, {
            w: "80px",
            textAlign: "center"
        }, rankIndex + 1), /*#__PURE__*/ React.createElement(Td, {
            w: "25%",
            minW: "250px"
        }, /*#__PURE__*/ React.createElement(Text, {
            "data-testid": "item-option-text",
            py: 1,
            px: 2,
            color: 'blue.500',
            bg: 'blue.100',
            fontSize: 'sm',
            fontWeight: 'medium',
            rounded: 'md',
            d: 'inline-flex'
        }, tapAnswersLabelsHash[answerId])), /*#__PURE__*/ React.createElement(Td, {
            "data-testid": "average-rank-column",
            w: '20%',
            minW: '100px',
            fontWeight: 'medium',
            letterSpacing: 'tight'
        }, averageRank), ranks && ranks.map(function(numRespondents, i) {
            return /*#__PURE__*/ React.createElement(Td, {
                key: "".concat(answerId, "-").concat(i),
                letterSpacing: 'tight',
                textAlign: 'center'
            }, usePercentage ? "".concat((100 * (numRespondents / total)).toFixed(2), "%") : numRespondents);
        }));
    }))));
};
